import React from 'react';
import { Grid } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { findIndex, isNil } from 'lodash';
import * as classnames from 'classnames';
import { ANALYSIS_DATA_ANALYSIS_SECTION, ANALYSIS_PROJECTS_LIST_SECTION } from '../data/actions';

const Header = props => {
  /**
   * Single Project Menu Structure
   * @type {*[]}
   */
  const analysisMenu = [
    {
      label: 'Analyze',
      width: 4,
      subMenu: [
        {
          link: `/analysis`,
          label: 'Projects List',
          slug: ANALYSIS_PROJECTS_LIST_SECTION
        },
        {
          link: null,
          label: 'Analysis',
          slug: ANALYSIS_DATA_ANALYSIS_SECTION
        }
      ]
    },
    {
      label: '',
      width: 12,
      subMenu: [
        {
          link: null,
          label: null,
          slug: null
        }
      ]
    }
  ];

  const headerRows = analysisMenu.map((menu, i) => {
    const isSubMenuActive =
      findIndex(menu.subMenu, subMenu => {
        return subMenu.slug === props.section;
      }) >= 0;

    const classes = classnames({
      'sub-menu__title--active': isSubMenuActive,
      'sub-menu__title': true,
      [`sub-menu__title--step${i + 1}`]: true
    });

    return (
      <Grid.Column key={menu.label} className={classes} width={menu.width}>
        {menu.label}
      </Grid.Column>
    );
  });

  const subMenuCols = analysisMenu.map((menu, i) => {
    const columns = menu.subMenu.map((subMenu, k) => {
      const classes = classnames({
        'sub-menu__sub-title--active': subMenu.slug === props.section,
        'sub-menu__sub-title': true
      });

      if (isNil(subMenu.link)) {
        return (
          <Grid.Column key={subMenu.label} className={classes}>
            {subMenu.label}
          </Grid.Column>
        );
      }

      return (
        <Grid.Column key={subMenu.label} className={classes}>
          <Link to={subMenu.link}>{subMenu.label}</Link>
        </Grid.Column>
      );
    });

    return (
      <Grid.Column
        key={menu.label}
        className="sub-menu__sub-section sub-menu__sub-analysis sub-menu__sub-section--no-padding "
        width={menu.width}
      >
        <Grid columns={columns.length} celled className="sub-menu__sub-section-container">
          {columns}
        </Grid>
      </Grid.Column>
    );
  });

  return (
    <div className="sub-menu sub-menu__analysis">
      <Grid celled columns={3}>
        <Grid.Row>{headerRows}</Grid.Row>
      </Grid>

      <Grid celled>
        <Grid.Row>{subMenuCols}</Grid.Row>
      </Grid>
    </div>
  );
};

Header.propTypes = {};

export default Header;



// WEBPACK FOOTER //
// ./src/scenes/analysis/components/Header.js